import React from "react";
import Reserved from "../components/Reserved";

export default (a, b, asString = false) => {
  const single = (d, isComplex) => {
    let i = 0;
    for (let v = 1; v < 100; v *= 10) {
      if (Math.abs(Math.round(d * v) - d * v) < 1e-6) break;
      ++i;
    }
    const v = d.toFixed(i);
    return asString ? (
      isComplex ? (
        v + "i"
      ) : (
        v
      )
    ) : (
      <Reserved
        value={
          v === "0"
            ? ""
            : isComplex
            ? v === "1"
              ? "i"
              : v === "-1"
              ? "-i"
              : v + "i"
            : v
        }
        reserve={isComplex ? "8.88i" : "-8.88"}
      />
    );
  };

  if (Math.abs(b) < 1e-6) return single(a);
  if (Math.abs(a) < 1e-6) return single(b, true);

  if (b < 0) {
    return asString ? (
      single(a) + " - " + single(-b, true)
    ) : (
      <span>
        {single(a)} - {single(-b, true)}
      </span>
    );
  }
  return asString ? (
    single(a) + " + " + single(b, true)
  ) : (
    <span>
      {single(a)} + {single(b, true)}
    </span>
  );
};
